import {FormControl, FormField, Separator} from 'platform/components';
import {Heading, Show} from 'platform/foundation';

import {useWatch} from 'react-hook-form';

import {useListEmailCredentialsQuery} from '@dms/api/core';
import i18n from '@dms/i18n';

import {FormValues} from '../types/FormValues';

interface SmtpCredentialsProps {
  control: FormControl<FormValues>;
}

export function SmtpCredentials(props: SmtpCredentialsProps) {
  const [isEmailEnabled, isAutomatizationEnabled] = useWatch({
    control: props.control,
    name: ['emailEnabled', 'enabled'],
  });

  const {data: userSmtpCredentials, isLoading: isLoadingUserSmtpCredentials} =
    useListEmailCredentialsQuery({ownerType: 'tenant'});

  const smtpCredentialsOptions =
    userSmtpCredentials?.credentials?.map((credential) => ({
      label: `${credential.title} (${credential.emailAddress})`,
      value: credential.id,
    })) ?? [];

  return (
    <Show when={isEmailEnabled}>
      <Separator spacing={0} />
      <Heading size={4}>{i18n.t('page.integrations.labels.serverSMTP.settings')}</Heading>

      <FormField
        type="choice"
        control={props.control}
        isDisabled={!isAutomatizationEnabled}
        name="emailCredentialsId"
        isLoading={isLoadingUserSmtpCredentials}
        options={smtpCredentialsOptions}
        isRequired={isAutomatizationEnabled}
      />
    </Show>
  );
}
